/* eslint-disable dot-notation */
/* eslint-disable react-native/no-inline-styles */
import React, { useState } from 'react';
import { View } from 'react-native';
import { Button, Card, Text, TextInput } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import { setCartOrderNote } from '../../store/cart.slice';
import { theme } from '../../theme/theme';
const CARD_ROUNDNESS = 1;
const CARD_ELEVATION = 0;

function CartNotes(props) {
    const dispatch = useDispatch();
    const cart_order_note = useSelector(state => state.cart.canteens[props?.canteen_id]['order_note']);
    const [orderNote, setOrderNote] = useState(cart_order_note || '');
    const [editOrderNote, setEditOrderNote] = useState(true);

    const saveOrderNote = () => {
        dispatch(setCartOrderNote({
            canteen_id: props?.canteen_id,
            order_note: orderNote,
        }));
        setEditOrderNote(t => !t);
    };

    const clearOrderNote = () => {
        setOrderNote('');
        setEditOrderNote(true);
        dispatch(setCartOrderNote({
            canteen_id: props?.canteen_id,
            order_note: '',
        }));
    };

    return (
        <Card elevation={CARD_ELEVATION} style={{ backgroundColor: '#ffffff', marginVertical: 4 }} theme={{ roundness: CARD_ROUNDNESS }}>
            <Card.Content>
                <Text variant="titleSmall">Add Note</Text>
                <TextInput multiline={true} editable={editOrderNote} maxLength={255} value={orderNote} onChangeText={setOrderNote} placeholder="Note for order" style={{ marginVertical: 4, fontSize: 12 }} right={!!orderNote && <TextInput.Icon onPress={saveOrderNote} icon={editOrderNote ? 'check' : 'pencil'} color={theme.colors.primary} />} />
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
                    <Text style={{ fontSize: 12 }}>Maximum 255 characters only</Text>
                    {!!orderNote && <Button
                        onPress={clearOrderNote}
                        mode="text">
                        Clear
                    </Button>
                    }
                </View>
            </Card.Content>
        </Card>
    );
}

export default CartNotes;
